import React from 'react'

import withSlidableJobPopulation from '../HOCs/withSlidableJobList'

import JobBlock from './../jobBlock'
import DataSource from './dataSource'

const SearchJobs = withSlidableJobPopulation(
    JobBlock,
    (props) => DataSource(props.languageCode, props.body),
    false,
    'section-featured-jobs'
)

export default SearchJobs
